import {
    ChangeDetectionStrategy,
    Component,
    inject,
    Input,
    OnChanges,
} from '@angular/core';
import { StatisticGroupComponent } from './statistic-group.component';

@Component({
    selector: 'pf-statistic',
    templateUrl: './statistic.component.html',
    styleUrls: ['./statistic.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StatisticComponent implements OnChanges {
    private group = inject(StatisticGroupComponent, {
        optional: true,
        host: true,
    });

    @Input() pfTitle!: string;
    private _pfValue!: string | number | undefined;
    private _pfIsAccounting = false;
    stringValueText?: string;

    @Input() set pfValue(value: string | number | undefined | null) {
        this._pfValue = value === null ? undefined : value;
        this.stringValueText = value && isNaN(+value) ? value.toString() : '';
        this.calculateColor();
    }

    get pfValue(): string | number | undefined {
        return this._pfValue;
    }

    @Input() set pfIsAccounting(isAccounting: boolean | undefined) {
        this._pfIsAccounting = !!isAccounting;
        this.calculateColor();
    }

    get pfIsAccounting() {
        return this._pfIsAccounting;
    }

    @Input() accountingUpperValue = 500;
    @Input() accountingLowerValue = 0;

    @Input() pfSize?: 'small' | 'large';
    @Input() pfColor?: string;

    ngOnChanges(): void {
        if (this.group) {
            this.group.setStat(this.pfTitle, this.pfValue as number);
        }
    }

    private calculateColor() {
        if (this._pfIsAccounting && this._pfValue && !isNaN(+this._pfValue)) {
            this.pfColor =
                +this._pfValue < this.accountingLowerValue ||
                +this._pfValue > this.accountingUpperValue
                    ? 'var(--ant-error-color)'
                    : 'var(--ant-success-color)';
        }
    }
}
